import dotProp from 'dot-prop-immutable'
import {
  FINISH_RESIZING_PRODUCT,
  PRODUCTS_ARE_LOADING,
  PRODUCTS_FAILED,
  PRODUCTS_LOADED,
  SETS_LOADED,
  START_RESIZING_PRODUCT,
} from '../constants/productsActions'
import { fillDimensions } from '../utils'
import filterOnlyProducts from './products/filterOnlyProducts'
import filterOnlySets from './products/filterOnlySets'

export const loadProducts = getProducts => (dispatch, ownState) => {
  if (0 !== dotProp.get(ownState(), 'products.images', []).length) {
    return
  }

  dispatch({ type: PRODUCTS_ARE_LOADING })
  getProducts()
    .then(res => Promise.all([filterOnlySets(res), filterOnlyProducts(res, window)]))
    .then(data => {
      dispatch({ type: PRODUCTS_LOADED, images: fillDimensions(data[1]) })
      dispatch({ type: SETS_LOADED, images: data[0] })
    })
    .catch(err => dispatch({ type: PRODUCTS_FAILED, message: err.message }))
}

export const startResize = index => ({ index, type: START_RESIZING_PRODUCT })
export const finishResize = () => ({ type: FINISH_RESIZING_PRODUCT })



// WEBPACK FOOTER //
// ./src/actions/products.js